export default __webpack_public_path__ + "static/media/header-img.66dab62c.png";